import { productBaseUrl } from "../store/api/routes";
import axiosInstance from "./axiosUtil";
import { getError } from "./error";

export const uploadFile = async ({
  file,
  productId,
  fileType,
  token,
  percentHandler,
}) => {
  try {
    const bodyFormData = new FormData();
    // const baseUrl = productBaseUrl;
    // console.log(fileType);
    let url;
    switch (fileType) {
      case "image":
        bodyFormData.append("file", file);
        url = `/api/v1/upload`;
        break;

      case "multi-image":
        [...file].forEach((f) => {
          bodyFormData.append("image", f);
        });
        url = "/api/multi-image";
        break;

      // case "application/pdf":
      //   bodyFormData.append("file", file);
      //   url = "/api/v1/upload";
      //   break;
      default:
        bodyFormData.append("file", file);
        url = "/api/v1/upload";
        break;
    }

    const options = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);
        percentHandler(percent);
        console.log(`${loaded}kb of ${total}kb | ${percent}`);
      },
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    };

    // console.log(url, bodyFormData, options);
    const { data } = await axiosInstance.post(url, bodyFormData, options);
    console.log(data);
    // if (fileType === "image" && data.image) {
    //   console.log("imageUrl", data.image);
    //   return data.image;
    // } else if (fileType === "pdf") {
    //   console.log("pdfurl", data.pdfUrl);
    //   return data.pdfUrl;
    // }
    return data;
  } catch (err) {
    return { error: getError(err) };
  }
};

export const uploadImage = async (file, token, percentHandler) => {
  try {
    const bodyFormData = new FormData();
    bodyFormData.append("image", file);
    const options = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);
        percentHandler(percent);
        console.log(`${loaded}kb of ${total}kb | ${percent}`);
      },
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    };
    const { data } = await axiosInstance.post(
      "/api/admin/image",
      bodyFormData,
      options
    );
    if (data.data.location) {
      console.log("location", data.data.location);
      return data.data.location;
    }
  } catch (err) {
    return { error: getError(err) };
  }
};

export const uploadMultiImage = async (files, token, percentHandler) => {
  try {
    // console.log('files1', typeof files)
    const bodyFormData = new FormData();
    [...files].forEach((file) => {
      bodyFormData.append("image", file);
    });

    const options = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);
        percentHandler(percent);
        console.log(`${loaded}kb of ${total}kb | ${percent}`);
      },
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    };
    const { data } = await axiosInstance.post(
      "/api/admin/multi-image",
      bodyFormData,
      options
    );
    if (data.data.location) {
      return data.data.location;
    }
  } catch (err) {
    return { error: getError(err) };
  }
};
